import Component from './Status';
export default Component;

export const componentName = 'Status';
